import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import SelectResearch from '../components/SelectResearch';

const createOptions = (
	items = [],
	selected = null,
	defaultText,
	type = null
) => {
	if (type) {
		const valueName =
			type === 'regione' ? 'slug_regione' : 'sigla_provincia';
		const options = items.map((item) => {
			return (
				<option
					key={item[valueName]}
					value={item[valueName]}
					selected={selected === item[valueName]}
					data-name={item[type]}
				>
					{item[type]}
				</option>
			);
		});
		options.unshift(<option value="0">{defaultText}</option>);
		return options;
	}
	const options = items.map((item) => {
		return (
			<option
				key={item}
				value={item}
				selected={selected === item}
				data-name={item}
			>
				{item}
			</option>
		);
	});
	options.unshift(<option value="0">{defaultText}</option>);
	return options;
};

const SectionLocalita = ({
	regioniArray,
	regione,
	provincia,
	citta,
	updateField,
}) => {
	const [regioni, setRegioni] = useState([]);
	const [province, setProvince] = useState([]);
	const [cities, setCitta] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
			if (provincia === '0') {
				setCitta(createOptions([], '0', 'Scegli una città'));
				return;
			}
			const resultCitta = await axios(
				`${window.location.origin}/wp-json/tsm-v1/cities_by_province/${provincia}`
			);
			setCitta(
				createOptions(resultCitta.data, citta, 'Scegli una città')
			);
		};
		fetchData();
	}, [provincia]);

	useEffect(() => {
		const fetchData = async () => {
			setCitta(createOptions([], '0', 'Scegli una città'));
			if (regione === '0') {
				setProvince(createOptions([], '0', 'Scegli una provincia'));
				return;
			}

			const slugRegione = regione.toLowerCase().split('-')[0];
			const resultProvince = await axios(
				`${window.location.origin}/wp-json/tsm-v1/provinces/${slugRegione}`
			);
			setProvince(
				createOptions(
					resultProvince.data,
					provincia,
					'Scegli una provincia',
					'provincia'
				)
			);
		};
		fetchData();
	}, [regione]);

	useEffect(() => {
		setRegioni(
			createOptions(
				regioniArray,
				regione,
				'Scegli una regione',
				'regione'
			)
		);
	}, [regioniArray]);

	return (
		<div className="section-localita p-b-24">
			<p className="section-title m-b-16 m-t-16 has-text-weight-semibold">
				Località
			</p>
			<div className="columns is-multiline">
				<div className="column is-half-tablet is-full-widescreen">
					<SelectResearch
						items={regioni}
						name="regione"
						updateField={updateField}
					/>
				</div>
				<div className="column is-half-tablet is-full-widescreen">
					<SelectResearch
						items={province}
						name="provincia"
						updateField={updateField}
						disabled={regione === '0'}
					/>
				</div>
				<div className="column is-half-tablet is-full-widescreen">
					<SelectResearch
						items={cities}
						name="citta"
						updateField={updateField}
						disabled={provincia === '0' || regione === '0'}
					/>
				</div>
			</div>
		</div>
	);
};

SectionLocalita.propTypes = {
	regioniArray: PropTypes.instanceOf(Array).isRequired,
	regione: PropTypes.instanceOf(String).isRequired,
	provincia: PropTypes.instanceOf(String).isRequired,
	citta: PropTypes.instanceOf(String).isRequired,
	updateField: PropTypes.instanceOf(Function).isRequired,
};

export default SectionLocalita;
